import React, { Component } from "react";
import PropTypes from "prop-types";
import { browserHistory } from "react-router";
import translate from "react-i18next/dist/commonjs/translate";
class IncidentsWidgetTable extends Component {
  constructor(props) {
    super(props);
    this.redirectToIncidentPage = this.redirectToIncidentPage.bind(this);
  }

  redirectToIncidentPage(incident) {
    browserHistory.push(
      `${global.applicationPath}/incidents/${incident.id}/${incident.status}`
    );
  }

  render() {
    const { incidents, t } = this.props;
    return (
      <table className="table table-responsive">
        <thead>
          <tr>
            <th className="col-xs-1">{t("incidentWidgetTablePriority")}</th>
            <th className="col-xs-1">{t("incidentWidgetTableDate")}</th>
            <th className="col-xs-10">{t("incidentWidgetTableSubject")}</th>
          </tr>
        </thead>
        <tbody>
          {incidents.map((i, k) => (
            <tr
              className="clickable"
              id={i.id}
              key={k}
              onClick={() => {this.redirectToIncidentPage(i)} }
            >
              <td>
                <div className={`incidentPriority${i.priority} severity-box`}>
                  {i.priority}
                </div>
              </td>
              <td>{i.date}</td>
              <td>{i.subject}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}

IncidentsWidgetTable.propTypes = {
  incidents: PropTypes.arrayOf(
    PropTypes.shape({
      subject: PropTypes.string.isRequired,
      priority: PropTypes.number.isRequired,
      date: PropTypes.string.isRequired
    })
  ).isRequired
};

export default translate("translations")(IncidentsWidgetTable);



// WEBPACK FOOTER //
// ./src/dashboard/widgets/IncidentsWidgetTable.js